
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/come-back",
      function () {
        return require("private-next-pages/come-back.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/come-back"])
      });
    }
  